// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"AwardView_Wrapper__14a57","Image":"AwardView_Image__182Ig","Text":"AwardView_Text__2-fci","Winner":"AwardView_Winner__33zjf"};